import { render, staticRenderFns } from "./UpdateStudent.vue?vue&type=template&id=7fe367f8&scoped=true"
import script from "./UpdateStudent.vue?vue&type=script&lang=js"
export * from "./UpdateStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe367f8",
  null
  
)

export default component.exports